import {
  Scene,
  WebGLRenderer,
  VSMShadowMap,
  SRGBColorSpace,
  ACESFilmicToneMapping,
  LinearToneMapping,
  PCFSoftShadowMap,
  NeutralToneMapping,
} from 'three'

let canvas: HTMLElement
const sizes = useSizes()
let scene: Scene
let instance: WebGLRenderer

export default function useRenderer(
  _canvas?: HTMLCanvasElement,
  _scene?: Scene
) {
  if (_scene && _canvas) {
    canvas = _canvas
    scene = _scene

    instance = new WebGLRenderer({
      canvas: canvas,
      antialias: true,
      preserveDrawingBuffer: true,
    })

    instance.shadowMap.enabled = true
    instance.outputColorSpace = SRGBColorSpace
    instance.shadowMap.type = PCFSoftShadowMap
    instance.toneMapping = NeutralToneMapping
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    instance.setSize(sizes.width.value, sizes.height.value)
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  function resize() {
    instance.setSize(sizes.width.value, sizes.height.value)
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  function update() {
    const camera = useCamera()
    instance.render(scene, camera.instance)
  }

  return {
    instance,
    update,
    resize,
    scene,
  }
}
